import { ReactNode } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import { useAuth } from 'react-oidc-context'
import { useAuthStore, hasAnyRole } from '@/stores/auth-store'
import { LoadingOverlay } from '@/components/ui'

interface ProtectedRouteProps {
  children: ReactNode
  requiredRoles?: string[]
}

export function ProtectedRoute({ children, requiredRoles }: ProtectedRouteProps) {
  const auth = useAuth()
  const { user, isLoading } = useAuthStore()
  const location = useLocation()

  // Show loading while auth state is being determined
  if (auth.isLoading || isLoading) {
    return <LoadingOverlay message="Authenticating..." />
  }

  // Redirect to login if not authenticated
  if (!auth.isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  // Check required roles if specified
  if (requiredRoles && requiredRoles.length > 0) {
    if (!hasAnyRole(user, requiredRoles)) {
      return (
        <div className="min-h-screen flex items-center justify-center">
          <div className="text-center">
            <h1 className="text-2xl font-bold text-slate-900 dark:text-white mb-2">
              Access Denied
            </h1>
            <p className="text-slate-500 dark:text-slate-400">
              You do not have permission to access this page.
            </p>
          </div>
        </div>
      )
    }
  }

  return <>{children}</>
}
